import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _c(
        VDialog,
        {
          attrs: { width: "500", persistent: "" },
          model: {
            value: _vm.showDialog,
            callback: function ($$v) {
              _vm.showDialog = $$v
            },
            expression: "showDialog",
          },
        },
        [
          _c(
            VCard,
            [
              _c(
                VCardTitle,
                {
                  staticClass: "headline lighten-2",
                  attrs: { "primary-title": "" },
                },
                [_vm._v("\n        " + _vm._s(_vm.dialogTitle) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                VIcon,
                {
                  staticClass: "close-button",
                  attrs: { color: "grey" },
                  on: { click: _vm.closeDialog },
                },
                [_vm._v("close")]
              ),
              _vm._v(" "),
              _vm.isInitial
                ? _c("file-upload", {
                    attrs: {
                      "upload-field-name": _vm.uploadFieldName,
                      "is-saving": _vm.isSaving,
                      source: "linePricingGroups",
                    },
                    on: { save: _vm.save },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isSaving && !_vm.isFailed
                ? _c(
                    "div",
                    [
                      _c(VCardText, [
                        _c("div", { staticClass: "container grid-list-md" }, [
                          _c("div", { staticClass: "layout wrap" }, [
                            _c("div", { staticClass: "flex xs12" }, [
                              _c("div", { staticClass: "v-input" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t(
                                        "settings.architecture.linePricingGroups.upload.uploadingState"
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isValidated
                ? _c(
                    "div",
                    [
                      _c(VCardText, [
                        _c("div", { staticClass: "container grid-list-md" }, [
                          _c("div", { staticClass: "layout wrap" }, [
                            _c("div", { staticClass: "flex xs12" }, [
                              _c(
                                "div",
                                { staticClass: "dialog-copy" },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        VIcon,
                                        { attrs: { color: "green darken-2" } },
                                        [_vm._v("check_circle")]
                                      ),
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "settings.architecture.linePricingGroups.upload.validationSuccessful"
                                            )
                                          ) +
                                          "\n                  "
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(VFlex, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "settings.architecture.linePricingGroups.upload.articlesReceived"
                                          )
                                        ) +
                                        ":\n                    "
                                    ),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.counts.articlesReceived)
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(VFlex, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "settings.architecture.linePricingGroups.upload.articlesToUnassign"
                                          )
                                        ) +
                                        ":\n                    "
                                    ),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.counts.articlesToUnassign)
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _vm.isArchitectureGroupImport
                                    ? _c(VFlex, [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "settings.architecture.linePricingGroups.upload.importScope"
                                              )
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "settings.architecture.linePricingGroups.upload.architectureGroup"
                                              )
                                            ) +
                                            "\n                  "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(VFlex, [
                                    _vm.counts.articlesToUnassign > 0
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "settings.architecture.linePricingGroups.upload.aboutToUnassignLinePricingGroups"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "settings.architecture.linePricingGroups.upload.confirmUpload"
                                          )
                                        ) +
                                        "\n                  "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(VDivider),
                      _vm._v(" "),
                      _c(
                        VCardActions,
                        [
                          _c(VSpacer),
                          _vm._v(" "),
                          _c(
                            VBtn,
                            {
                              staticClass: "dialog-button",
                              attrs: {
                                color: "primary",
                                outlined: "",
                                depressed: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.reset()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("actions.cancel")))]
                          ),
                          _vm._v(" "),
                          _c(
                            VBtn,
                            {
                              staticClass: "primary dialog-button",
                              attrs: {
                                depressed: "",
                                loading: _vm.busyImportingLinePricingGroups,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.confirm()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("actions.upload")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isFailed
                ? _c(
                    "div",
                    [
                      _c(VCardText, [
                        _c("div", { staticClass: "container grid-list-md" }, [
                          _c("div", { staticClass: "layout wrap" }, [
                            _c(
                              "div",
                              { staticClass: "flex xs12" },
                              [
                                _vm.hasUnhandledError
                                  ? [
                                      _c("upload-error-card", {
                                        attrs: {
                                          "error-message":
                                            _vm.$t("errors.generic"),
                                          "unique-key-prefix": "genericError",
                                        },
                                      }),
                                    ]
                                  : _vm.uploadError.tooManyRows
                                  ? [
                                      _c("div", { staticClass: "v-input" }, [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "settings.architecture.linePricingGroups.upload.tooManyRows",
                                                {
                                                  maxRows: _vm.maxRows,
                                                }
                                              )
                                            ) +
                                            "\n                  "
                                        ),
                                      ]),
                                    ]
                                  : [
                                      _vm.uploadError.duplicateProductKeys
                                        .length
                                        ? _c("upload-error-card", {
                                            attrs: {
                                              "error-message": _vm.$t(
                                                "settings.architecture.linePricingGroups.upload.duplicateProductKey"
                                              ),
                                              details:
                                                _vm.uploadError
                                                  .duplicateProductKeys,
                                              "unique-key-prefix":
                                                "duplicateProductKey",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.uploadError
                                        .productKeysWithIncorrectTSGs.length
                                        ? _c("upload-error-card", {
                                            attrs: {
                                              "error-message": _vm.$t(
                                                "attributes.upload.incorrectToolStoreGroups"
                                              ),
                                              details:
                                                _vm.uploadError
                                                  .productKeysWithIncorrectTSGs,
                                              "unique-key-prefix":
                                                "incorrectToolStoreGroups",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.uploadError
                                        .productKeysWithInvalidLinePriceFactor
                                        .length
                                        ? _c("upload-error-card", {
                                            attrs: {
                                              "error-message": _vm.$t(
                                                "settings.architecture.linePricingGroups.upload.productKeysWithInvalidLinePriceFactor"
                                              ),
                                              details:
                                                _vm.uploadError
                                                  .productKeysWithInvalidLinePriceFactor,
                                              "unique-key-prefix":
                                                "productKeysWithInvalidLinePriceFactor",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.uploadError
                                        .duplicateLinePricingGroupNames.length
                                        ? _c("upload-error-card", {
                                            attrs: {
                                              "error-message": _vm.$t(
                                                "settings.architecture.linePricingGroups.upload.duplicateLinePricingGroupNames"
                                              ),
                                              details:
                                                _vm.uploadError
                                                  .duplicateLinePricingGroupNames,
                                              "unique-key-prefix":
                                                "duplicateLinePricingGroupNames",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.uploadError
                                        .productKeysWithMissingHierarchies
                                        .length
                                        ? _c("upload-error-card", {
                                            attrs: {
                                              "error-message": _vm.$t(
                                                "settings.architecture.linePricingGroups.upload.missingHierarchies"
                                              ),
                                              details:
                                                _vm.uploadError
                                                  .productKeysWithMissingHierarchies,
                                              "unique-key-prefix":
                                                "missingHierarchies",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.uploadError
                                        .productKeysWithInvalidSubgroups &&
                                      _vm.uploadError
                                        .productKeysWithInvalidSubgroups.length
                                        ? _c("upload-error-card", {
                                            attrs: {
                                              "error-message": _vm.$t(
                                                "settings.architecture.linePricingGroups.upload.productKeysWithInvalidSubgroups"
                                              ),
                                              details:
                                                _vm.uploadError
                                                  .productKeysWithInvalidSubgroups,
                                              "unique-key-prefix":
                                                "productKeysWithInvalidSubgroups",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                              ],
                              2
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(VDivider),
                      _vm._v(" "),
                      _c(
                        VCardActions,
                        [
                          _c(VSpacer),
                          _vm._v(" "),
                          _c(
                            VBtn,
                            {
                              staticClass: "primary",
                              on: {
                                click: function ($event) {
                                  return _vm.closeDialog()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("actions.close")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }